import { Menu } from "antd";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import { CommonProps } from "../common/common-props";

interface SubMenuProps {}

interface SubMenuState {}

class SubMenu extends PureComponent<SubMenuProps & CommonProps, SubMenuState> {
  constructor(props: SubMenuProps) {
    super(props);
    this.state = {};
  }

  getProps = () => {
    const props: any = _.clone(this.props);
    if (props.icon) {
      props.icon = <span className="material-icons md-24">{props.icon}</span>;
    }
    if (props.label) {
      props.title = props.label;
    }
    if (props.link) {
      props.children = (
        <a href={props.link} target="_self">
          {props.label}
        </a>
      );
    }
    props.key = props.key ?? props.id ?? Guid.create().toString();
    delete props.children;
    return props;
  };

  render(): ReactNode {
    return <Menu.SubMenu {...this.getProps()}>{this.props.children}</Menu.SubMenu>;
  }
}

const subMenu = withCommonEvents(SubMenu);
export { subMenu as SubMenu };
